import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";

import { AdaaHelper } from "../../core/utils";
import { Constants } from "../../shared/constants/constants";
import { LoginResponse } from "../../shared/models";

export const adaa4UserGuard: CanActivateFn = () => {
  const user = AdaaHelper.getLocalStorage(Constants.localStorageKeys.user, { type: "json" }) as
    LoginResponse | undefined;
  if (user?.adaa4) return true;

  return inject(Router).createUrlTree(["/"]);
};
